<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="filter-select">
          <vue-select
            :options="optionsFilter"
            label="label"
            placeholder="Filtrar"
            @input="onChangeFilter"
            :clearable="false"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            show-expand
            :single-expand="true"
            :expanded.sync="expanded"
          >
            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <template v-slot:expanded-item="{ headers, item }">
              <td colspan="9">
                <div class="table-expanded">
                  <h6>Equipes vinculadas</h6>
                  <table class="table table-interna">
                    <thead>
                      <tr>
                        <th>INE</th>
                        <th>Equipe</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{
                            item.equipe_vinculada != null
                              ? item.equipe_vinculada.nu_ine
                              : ''
                          }}
                        </td>
                        <td>
                          {{
                            item.equipe_vinculada != null
                              ? item.equipe_vinculada.no_equipe
                              : ''
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <b-alert v-if="item.ine_ativo == 0" variant="danger" show>
                    Equipe inativa. Para reativá-la, o administrador do e-SUS
                    municipal deve baixar o arquivo XML no SIAPS ou SISAB e
                    importar na aba CNES do Prontuário Eletrônico ou
                    Centralizador municipal.
                  </b-alert>
                </div>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'Unidade de saúde',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Tipo equipe',
          align: 'start',
          filterable: false,
          value: 'sg_tipo_equipe',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      optionsFilter: [
        {
          label: 'Ativas',
          value: 'ativas',
        },
        {
          label: 'Vinculadas',
          value: 'vinculadas',
        },
        {
          label: 'Inativas',
          value: 'inativas',
        },
      ],
      filtroSelecionado: 'ativas',
      cadastrosFiltrados: [],
    }
  },
  computed: {
    indexedItems() {
      // usa cadastrosFiltrados se existir, senão usa cadastros original
      const base = this.cadastrosFiltrados.length
        ? this.cadastrosFiltrados
        : this.cadastros

      return base.map((item, index) => {
        let dados = JSON.parse(item.dados) ?? null

        return {
          id: index,
          nu_cnes: dados.nu_cnes,
          no_unidade_saude: dados.no_unidade_saude,
          nu_ine: dados.nu_ine,
          no_equipe: dados.no_equipe,
          sg_tipo_equipe: dados.sg_tipo_equipe,
          equipe_vinculada: dados.equipe_vinculada,
          ...item,
        }
      })
    },
  },

  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Manipula ao selecionar um filtro
     * @param {Object} option
     */
    onChangeFilter(option) {
      this.filtroSelecionado = option.value

      if (option.value === 'vinculadas') {
        this.cadastrosFiltrados = this.cadastros.filter((c) => {
          const dados = JSON.parse(c.dados)
          return dados.equipe_vinculada != null
        })
      } else if (option.value === 'ativas') {
        this.cadastrosFiltrados = this.cadastros.filter((c) => {
          return c.ine_ativo == 1
        })
      } else if (option.value === 'inativas') {
        this.cadastrosFiltrados = this.cadastros.filter((c) => {
          return c.ine_ativo == 0
        })
      } else {
        // volta ao padrão (todas)
        this.cadastrosFiltrados = []
      }

      // resetar página e expand
      this.currentPage = 1
      this.expanded = []
    },
  },
}
</script>

<style>
#equipes-saude .table-expanded {
  margin-top: 20px;
}

#equipes-saude .table-expanded table {
  margin-top: 10px;
}
</style>
